import { createSlice } from '@reduxjs/toolkit';

const menuSlice = createSlice({
  name: 'menu',
  initialState: {
    collapsed: false,
    selectedKeys: [],
    openKeys: [],
  },
  reducers: {
    setCollapsed: (state, action) => {
      state.collapsed = action.payload;
    },
    toggleCollapsed: (state) => {
      state.collapsed = !state.collapsed;
    },
    setSelectedKeys: (state, action) => {
      state.selectedKeys = action.payload;
    },
    setOpenKeys: (state, action) => {
      state.openKeys = action.payload;
    },
  },
});

export const { setCollapsed, toggleCollapsed, setSelectedKeys, setOpenKeys } =
  menuSlice.actions;

export const selectCollapsed = (state) => state.menu.collapsed;
export const selectSelectedKeys = (state) => state.menu.selectedKeys;
export const selectOpenKeys = (state) => state.menu.openKeys;

export default menuSlice.reducer;
